var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('div', {
    staticClass: "card-form container",
    attrs: {
      "id": "print"
    }
  }, [_c('div', {
    staticClass: "mb-5 w-100 d-flex justify-content-between"
  }, [_c('div', [_c('img', {
    staticClass: "max-h-40px",
    attrs: {
      "alt": "Logo",
      "src": _vm.layoutConfig('self.logo.secundary')
    }
  })]), _c('div', {
    staticClass: "mt-4"
  }, [_c('span', [_vm._v("Impressão - "), _c('label', [_vm._v(_vm._s(_vm.title))])]), _c('br')])]), _c('div', {
    staticClass: "col-12"
  }, [_c('b-card', {
    staticClass: "mb-2 border border-primary",
    attrs: {
      "title": "",
      "tag": "article"
    }
  }, [_c('b-card-text', [_vm.data.length > 0 ? _c('b-table', {
    attrs: {
      "striped": "",
      "small": "",
      "hover": "",
      "items": _vm.tableItems,
      "fields": _vm.tableFields
    }
  }) : _vm._e()], 1), _vm.totalSum > 0 ? _c('div', {
    staticClass: "d-flex justify-content-end mt-3"
  }, [_c('strong', [_vm._v("Total: " + _vm._s(_vm.numberToReal(_vm.totalSum)))])]) : _vm._e()], 1)], 1), _c('div', {
    staticClass: "mt-5 w-100 d-flex justify-content-end"
  }, [_c('img', {
    staticClass: "max-h-30px mr-5",
    attrs: {
      "alt": "Logo",
      "src": _vm.layoutConfig('self.logo.icone')
    }
  })])]), _c('div', {
    staticClass: "mt-5 w-100 d-flex justify-content-center d-print-none"
  }, [_c('button', {
    staticClass: "btn btn-success btn-hover-primary mr-2",
    on: {
      "click": _vm.printDocument
    }
  }, [_vm._v(" Imprimir ")]), _c('button', {
    staticClass: "btn btn-success btn-hover-primary mr-2",
    on: {
      "click": function click($event) {
        return _vm.$router.go(-1);
      }
    }
  }, [_vm._v(" Voltar ")])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };